module.exports = __webpack_public_path__ + "img/adds.5ab38ea3.svg";